import React from "react";
import { Container, Row } from "react-bootstrap";
import Marquee from "react-fast-marquee";

const Logos = ({ logos }) => {
	return (
		<section className="trusted-by py-5">
			<Container fluid>
				<Row className="justify-content-center ">
					<Marquee>
						{logos.map((item, i) => (
							<img
								src={item.image.sourceUrl}
								style={{ maxWidth: "160px" }}
								alt={item.image.altText}
								key={i}
								className="me-5"
							/>
						))}
					</Marquee>
				</Row>
			</Container>
			{/* <Container className="">
				<Row className="justify-content-center align-items-center  g-5 ">
					{logos.map((item, i) => (
						<Col className="text-center" lg={2}>
							<img
								src={item.image.sourceUrl}
								style={{ maxWidth: "160px" }}
								alt={item.image.altText}
								key={i}
							/>
						</Col>
					))}
				</Row>
			</Container> */}
		</section>
	);
};

export default Logos;
